import React from "react"
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import Details from "../components/DetailsContainer/DetailsContainerMain"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import OrderList from "../containers/OrderListContainer"
import UserList from "../containers/UserListContainer"
import seviceproviders from "../containers/SeviceProvidersContainer"
import Job from "../components/Job/JobMain"
import Admins from "../containers/AdminContainer"
import AdminProfile from "../containers/AdminProfileSection"
import Services from "../containers/ServicesContainer"
import createAdmin from "../components/AccountCreate/AccountCreate"
import Privacy from "../containers/Privacy"
import Terms from "../containers/Terms"

const userRoutes = [
  { path: "/dashboard", component: Dashboard },

  // // //profile
  { path: "/profile", component: UserProfile },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
]

const authRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/privacy", component: Privacy },
  { path: "/terms", component: Terms },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
  { path: "/users", component: UserList },
  { path: "/orders", component: OrderList },
  { path: "/details", component: Details },
  { path: "/job", component: Job },
  { path: "/seviceproviders", component: seviceproviders },
  { path: "/admins", component: Admins },
  { path: "/profiledata", component: AdminProfile },
  { path: "/services", component: Services },
  { path: "/createAdmin", component: createAdmin },
]

export { userRoutes, authRoutes }
